import { routes } from '@/features/v2/constants/routes';

export const homeV2 = {
  complete: {
    title: '¡Disfruta los torneos!',
    description: 'Demuestra tu habilidad, compite por',
    span: 'grandes premios',
    and: 'y vive la emoción al máximo.',
    button: 'PARTICIPA',
    buttonLink: routes.TOURNAMENTS,
  },
  kyc1: {
    title: '¡Bienvenido!',
    description: 'Completa tu perfil y valida tu identidad para redirmir tu',
    span: 'bono',
    and: 'y empezá a jugar.',
    button: 'COMPLETAR',
    buttonLink: routes.DASHBOARD,
  },
  noDeposit: {
    title: '¡PRIMER DEPÓSITO!',
    description: 'Realizá tu primer depósito para redimir tu',
    span: 'bono',
    and: 'y empezar la diversión.',
    button: 'DEPOSITAR',
    buttonLink: routes.DEPOSIT,
  },
  calendar: {
    title: 'Calendario',
    link: routes.SPORTS,
    textLink: 'Saber más',
  },
  tournament: {
    title: 'TORNEOS DEL MES',
    subtitle: '¡JUEGA Y GANA!',
    description: 'Todos nuestros usuarios',
    span: 'POWERBET ',
    and: 'están pendientes de nuestros torneos, ya que es una de las formas de aumentar sus',
    span2: 'ganancias',
    and2: 'de manera mas rápida.',
    link: routes.TOURNAMENTS,
    textLink: '¡JUGAR!',
  },
};
